import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import KeyValueList, { KeyValueItem } from '../ui/KeyValueList';

interface ReviewGroupProps {
  title: string;
  items: KeyValueItem[];
  /** Jumps back to the step that holds these fields. */
  onEdit: () => void;
  /** Disable editing while the project is being submitted. */
  editDisabled?: boolean;
}

/** One block of the Review step: a heading, an Edit action and the values entered. */
const ReviewGroup: React.FC<ReviewGroupProps> = ({ title, items, onEdit, editDisabled = false }) => (
  <Box component="section" aria-label={title} sx={{ px: 2.5, py: 2.25, borderTop: 1, borderColor: 'divider', '&:first-of-type': { borderTop: 0 } }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 1.75 }}>
      <Typography component="h3" sx={{ fontWeight: 700, fontSize: '0.9375rem' }}>
        {title}
      </Typography>
      <Button
        size="small"
        variant="text"
        startIcon={<EditOutlinedIcon sx={{ fontSize: 18 }} />}
        onClick={onEdit}
        disabled={editDisabled}
        aria-label={`Edit ${title.toLowerCase()}`}
        sx={{ flexShrink: 0 }}
      >
        Edit
      </Button>
    </Box>
    <KeyValueList items={items} />
  </Box>
);

export default ReviewGroup;
